var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Input from '@fp-suite/core-ui/src/components/Input';
import { Form } from 'antd';
import ScanDataTotes from './ScanDataTotes';
import ScanLocation from './ScanLocation';
import ScanAgainLocation from './ScanAgainLocation';
import ScanProduct from './ScanProduct';
import PlaceInTote from './PlaceInTote';
// import ConfirmDropItem from './ConfirmDropItem'
import PickComplete from './PickComplete';
import { getScannedLocation, 
// pickMoveContainerToPackStation,
confirmDropoff } from '../redux/authSlice';
import { useDispatch } from 'react-redux';
import MainHeading from './MainHeading';
import Heading from './Heading';
import DropLocation from './DropLocation';
import ScanProductQty from './ScanProductQty';
import { BsKeyboard, BsKeyboardFill } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
var PickSingle = function (_a) {
    var subscreenToBeSet = _a.subscreenToBeSet, currentPickRunTypeId = _a.currentPickRunTypeId, scannedTotesList = _a.scannedTotesList, setIsLoading = _a.setIsLoading, skipScanLocationScreen = _a.skipScanLocationScreen;
    var history = useHistory();
    var form = Form.useForm()[0];
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _b = useState(subscreenToBeSet ? subscreenToBeSet : skipScanLocationScreen ? 'scanCart' : 'scanStartLocation'), currentActiveSubscreen = _b[0], setCurrentActiveSubscreen = _b[1];
    var _c = useState(scannedTotesList), totesList = _c[0], setTotesList = _c[1];
    var _d = useState(null), cartScannedData = _d[0], setCartScannedData = _d[1];
    var scannedToteArrays = useState([])[0];
    var isToteScanned = useState(false)[0];
    var _e = useState(''), errorMsgText = _e[0], setErrorMsgText = _e[1];
    // const [, setScannedToteArrayAgain] = useState<any>([])
    var _f = useState(false), scannedLocationIncorrect = _f[0], setScannedLocationIncorrect = _f[1];
    var _g = useState(''), scannedDropLocation = _g[0], setScannedDropLocation = _g[1];
    var _h = useState(''), scannedPackingStation = _h[0], setScannedPackingStation = _h[1];
    var _j = useState(true), pickMoveContainerToPackingStation = _j[0], setPickMoveContainerToPackingStation = _j[1];
    var _k = useState(0), productQty = _k[0], setProductQty = _k[1];
    var _l = useState(''), lotDetail = _l[0], setLotDetail = _l[1];
    var _m = useState('none'), inputMode = _m[0], setInputMode = _m[1];
    var itemsCountData = localStorage.getItem('itemsCountData');
    if (itemsCountData) {
        itemsCountData = JSON.parse(itemsCountData);
    }
    else {
        itemsCountData = {
            totalItemsCount: 0,
            pickedItemsCount: 0
        };
    }
    var bulkPickItemsData = localStorage.getItem('bulkPickItemsData');
    if (bulkPickItemsData) {
        bulkPickItemsData = JSON.parse(bulkPickItemsData);
    }
    else {
        bulkPickItemsData = {
            totalItemsCount: 0,
            pickedItemsCount: 0
        };
    }
    useEffect(function () {
        if (!localStorage.getItem('goToLocationData')) {
            history === null || history === void 0 ? void 0 : history.push('/');
        }
        form.validateFields(['scannedCart']); // eslint-disable-next-line
    }, []);
    var onCartScanned = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event.key === 'Enter')) return [3 /*break*/, 2];
                    event.target.blur();
                    form.setFieldsValue({
                        scannedCart: ''
                    });
                    setIsLoading(true);
                    return [4 /*yield*/, dispatch(getScannedLocation({
                            scanLocationId: event.target.value,
                            setScannedLocationIncorrect: setScannedLocationIncorrect,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromScreen: 'scanCart',
                            subscreenName: 'scanTotes',
                            setErrorMsgText: setErrorMsgText,
                            setTotesList: setTotesList,
                            totesList: totesList,
                            pickRunTypeId: currentPickRunTypeId
                        }))];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    setScannedLocationIncorrect(false);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onToteScan = function (inputValue) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCurrentActiveSubscreen('scanLocation');
                    return [2 /*return*/];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onLocationScan = function (locationVal) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, dispatch(getScannedLocation({
                            scanLocationId: locationVal,
                            setScannedLocationIncorrect: setScannedLocationIncorrect,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            subscreenName: 'scanCart',
                            fromScreen: 'scanStartLocation',
                            setErrorMsgText: setErrorMsgText,
                            totesList: totesList,
                            setTotesList: setTotesList,
                            pickRunTypeId: currentPickRunTypeId
                        }))];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onLocationScanAgain = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, dispatch(getScannedLocation({
                            scanLocationId: event.target.value,
                            setScannedLocationIncorrect: setScannedLocationIncorrect,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            subscreenName: 'scanProduct',
                            fromScreen: 'scanLocationAgain',
                            setErrorMsgText: setErrorMsgText,
                            totesList: totesList,
                            setTotesList: setTotesList,
                            pickRunTypeId: currentPickRunTypeId
                        }))];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var OnProductScan = function (scanId, qty) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, dispatch(getScannedLocation({
                            scanLocationId: scanId,
                            setScannedLocationIncorrect: setScannedLocationIncorrect,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromScreen: 'scanProduct',
                            subscreenName: currentPickRunTypeId === 'PrtBulkPick' ? 'scanProductQty' : 'placeInTote',
                            setErrorMsgText: setErrorMsgText,
                            totesList: totesList,
                            setTotesList: setTotesList,
                            pickRunTypeId: currentPickRunTypeId
                        }))];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var OnProductQtyScan = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var itemsCountData, errMsg;
        return __generator(this, function (_a) {
            itemsCountData = localStorage.getItem('itemsCountData');
            if (itemsCountData) {
                itemsCountData = JSON.parse(itemsCountData);
            }
            else {
                itemsCountData = {
                    pickedItemsCount: 0,
                    totalItemsCount: 0
                };
            }
            errMsg = '';
            if (!Number.isInteger(Number(event.target.value))) {
                errMsg = t('Please enter a valid number!');
            }
            else if (Number(event.target.value) <= 0) {
                errMsg = t('Please enter qty greater than 0!');
            }
            else if (Number(event.target.value) >
                itemsCountData['totalItemsCount'] - itemsCountData['pickedItemsCount']) {
                errMsg = t("You can't pick qty greater than the available qty!");
            }
            else if (!event.target.value) {
                errMsg = t('This is a required field!');
            }
            if (errMsg) {
                setErrorMsgText(errMsg);
                setScannedLocationIncorrect(true);
                return [2 /*return*/];
            }
            setProductQty(event.target.value);
            setCurrentActiveSubscreen('placeInTote');
            return [2 /*return*/];
        });
    }); };
    var onAgainToteScan = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var hospitalContainers, hospitalContainersExist;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    hospitalContainers = localStorage.getItem('hospitalContainers');
                    if (hospitalContainers) {
                        hospitalContainers = JSON.parse(hospitalContainers);
                    }
                    else {
                        hospitalContainers = [];
                    }
                    hospitalContainersExist = hospitalContainers.length > 0 ? true : false;
                    if (currentPickRunTypeId !== 'PrtSingle' && currentPickRunTypeId !== 'PrtOrderLevel') {
                        hospitalContainersExist = false;
                    }
                    setIsLoading(true);
                    return [4 /*yield*/, dispatch(getScannedLocation({
                            scanLocationId: event.target.value,
                            setScannedLocationIncorrect: setScannedLocationIncorrect,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            fromScreen: 'placeTote',
                            subscreenName: hospitalContainersExist ? 'hospitalLocation' : 'packingStationLocation',
                            setErrorMsgText: setErrorMsgText,
                            totesList: totesList,
                            setTotesList: setTotesList,
                            pickRunTypeId: currentPickRunTypeId,
                            productQty: productQty,
                            lotId: (_a = lotDetail === null || lotDetail === void 0 ? void 0 : lotDetail.lotId) !== null && _a !== void 0 ? _a : ''
                        }))];
                case 1:
                    _b.sent();
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onDropLocationInputChange = function (value) {
        if (currentActiveSubscreen === 'hospitalLocation') {
            setScannedDropLocation(value);
        }
        else {
            setScannedPackingStation(value);
        }
    };
    var onConfirmDropoff = function (fromHospital) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, dispatch(confirmDropoff({
                            scanId: fromHospital ? scannedDropLocation : scannedPackingStation,
                            fromHospital: fromHospital,
                            setScannedLocationIncorrect: setScannedLocationIncorrect,
                            currentActiveSubscreen: currentActiveSubscreen,
                            setCurrentActiveSubscreen: setCurrentActiveSubscreen,
                            setErrorMsgText: setErrorMsgText,
                            pickMoveContainerToPackingStation: pickMoveContainerToPackingStation,
                            setPickMoveContainerToPackingStation: setPickMoveContainerToPackingStation,
                            pickRunTypeId: currentPickRunTypeId
                        }))];
                case 1:
                    _a.sent();
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var backBtn = function (screen) {
        setCurrentActiveSubscreen(screen);
    };
    // const onDropItem = () => {
    //   setCurrentActiveSubscreen('dropItemsConfirm')
    // }
    // const confirmItem = async () => {
    //   setIsLoading(true)
    //   let containers: any = localStorage.getItem('pickRunContainerList')
    //   if (containers) {
    //     containers = JSON.parse(containers)
    //   } else {
    //     containers = []
    //   }
    //   if (containers && containers.length > 0) {
    //     for (let i = 0; i < containers.length; i++) {
    //       if (pickMoveContainerToPackingStation) {
    //         await dispatch(
    //           pickMoveContainerToPackStation({
    //             containerId: containers[i]['containerId'],
    //             setPickMoveContainerToPackingStation
    //           })
    //         )
    //       } else {
    //         break
    //       }
    //     }
    //     if (pickMoveContainerToPackingStation) {
    //       setCurrentActiveSubscreen('finalStep')
    //     }
    //   }
    //   setIsLoading(false)
    // }
    // const onPackingCancel = () => {
    //   setScannedToteArrayAgain([])
    //   setCurrentActiveSubscreen('scanLocation')
    // }
    return (_jsxs("div", __assign({ className: 'px-4 sm:px-8 lg:px-16 pt-1 lg:pt-3 pb-16 h-screen w-full sm:w-4/5 md:w-3/5 lg:w-2/5 mx-auto' }, { children: [_jsx(MainHeading, { heading: t('Pick') + " " + (currentPickRunTypeId === 'PrtSingle'
                    ? t('Singles')
                    : currentPickRunTypeId === 'PrtOrderLevel'
                        ? t('Order Level')
                        : currentPickRunTypeId === 'PrtBulkSingle'
                            ? t('Bulk Singles')
                            : currentPickRunTypeId === 'PrtBulkPick'
                                ? t('Bulk')
                                : t('Multi')) + " - " + t('Item') + " " + (currentPickRunTypeId === 'PrtBulkPick'
                    ? (bulkPickItemsData === null || bulkPickItemsData === void 0 ? void 0 : bulkPickItemsData.pickedItemsCount) + " " + t('of') + " " + (bulkPickItemsData === null || bulkPickItemsData === void 0 ? void 0 : bulkPickItemsData.totalItemsCount)
                    : (itemsCountData === null || itemsCountData === void 0 ? void 0 : itemsCountData.pickedItemsCount) + " " + t('of') + " " + (itemsCountData === null || itemsCountData === void 0 ? void 0 : itemsCountData.totalItemsCount)) }, void 0), currentActiveSubscreen === 'scanCart' ? (_jsx("div", { children: _jsxs("div", __assign({ className: 'bg-white p-5 pb-0.5 rounded-lg shadow-sm' }, { children: [_jsx("div", __assign({ className: 'justify-between border-b-2 border-gray-300 my-3' }, { children: _jsx(Heading, { data: localStorage.getItem('pickRunId'), label: t('Pick Run Id') }, void 0) }), void 0), _jsxs("div", __assign({ className: 'flex items-center' }, { children: [_jsx(Form, __assign({ form: form, className: 'w-96' }, { children: _jsx(Form.Item, __assign({ validateStatus: scannedLocationIncorrect ? 'error' : '', help: scannedLocationIncorrect && errorMsgText, className: 'w-full', name: 'scannedCart' }, { children: _jsx(Input, { placeholder: '', title: t('Scan Cart'), onKeyDown: onCartScanned, autoFocus: true, inputMode: inputMode, allowClear: true, fromHandheld: true }, void 0) }), void 0) }), void 0), !inputMode ? (_jsx(BsKeyboardFill, { size: 32, className: 'mt-1 ml-2 cursor-pointer', color: '#093479', onClick: function () { return setInputMode('none'); } }, void 0)) : (_jsx(BsKeyboard, { size: 32, className: 'mt-1 ml-2 cursor-pointer', onClick: function () { return setInputMode(''); } }, void 0))] }), void 0)] }), void 0) }, void 0)) : currentActiveSubscreen === 'scanTotes' ? (_jsx(ScanDataTotes, { currentPickRunTypeId: currentPickRunTypeId, setIsLoading: setIsLoading, scanCart: cartScannedData, isToteScanned: isToteScanned, errorMsgText: errorMsgText, scannedToteArrays: scannedToteArrays, setErrorMsgText: setErrorMsgText, onToteScan: onToteScan, totesList: totesList, scannedLocationIncorrect: scannedLocationIncorrect, setScannedLocationIncorrect: setScannedLocationIncorrect, backBtn: function () { return backBtn('scanCart'); } }, void 0)) : !skipScanLocationScreen && currentActiveSubscreen === 'scanStartLocation' ? (_jsx(ScanLocation, { scanCart: cartScannedData, onLocationScan: onLocationScan, errorMsgText: errorMsgText, setCurrentScreen: setCurrentActiveSubscreen, scannedLocationIncorrect: scannedLocationIncorrect, setScannedLocationIncorrect: setScannedLocationIncorrect }, void 0)) : currentActiveSubscreen === 'scanLocation' ? (_jsx(ScanAgainLocation, { currentPickRunTypeId: currentPickRunTypeId, scanCart: cartScannedData, onLocationScanAgain: onLocationScanAgain, errorMsgText: errorMsgText, setCurrentScreen: setCurrentActiveSubscreen, scannedLocationIncorrect: scannedLocationIncorrect, setScannedLocationIncorrect: setScannedLocationIncorrect, backBtn: function () { return backBtn('scanTotes'); } }, void 0)) : currentActiveSubscreen === 'scanProduct' ? (_jsx(ScanProduct, { currentPickRunTypeId: currentPickRunTypeId, errorMsgText: errorMsgText, OnProductScan: OnProductScan, setCurrentScreen: setCurrentActiveSubscreen, scannedLocationIncorrect: scannedLocationIncorrect, setScannedLocationIncorrect: setScannedLocationIncorrect, setIsLoading: setIsLoading, from: 'pickSingle', backBtn: function () { return backBtn('scanLocation'); } }, void 0)) : currentActiveSubscreen === 'scanProductQty' ? (_jsx(ScanProductQty, { currentPickRunTypeId: currentPickRunTypeId, errorMsgText: errorMsgText, OnProductQtyScan: OnProductQtyScan, scannedLocationIncorrect: scannedLocationIncorrect, setScannedLocationIncorrect: setScannedLocationIncorrect, setIsLoading: setIsLoading, setLotDetail: setLotDetail, from: 'pickSingle', backBtn: function () { return backBtn('scanProduct'); } }, void 0)) : currentActiveSubscreen === 'placeInTote' ? (_jsx(PlaceInTote, { currentPickRunTypeId: currentPickRunTypeId, errorMsgText: errorMsgText, fromPickMultis: false, setError: setErrorMsgText, onAgainToteScan: onAgainToteScan, scannedLocationIncorrect: scannedLocationIncorrect, totesList: totesList, lotDetail: lotDetail, setScannedLocationIncorrect: setScannedLocationIncorrect, backBtn: function () {
                    return backBtn(currentPickRunTypeId === 'PrtBulkPick' ? 'scanProductQty' : 'scanProduct');
                } }, void 0)) : currentActiveSubscreen === 'hospitalLocation' ? (_jsx(DropLocation
            // onDropItem={onDropItem}
            , { 
                // onDropItem={onDropItem}
                currentPickRunTypeId: currentPickRunTypeId, inputTitle: t('Scan Hospital Location'), topTitle: t('Go To Hospital Location'), errorMsgText: errorMsgText, onDropLocationInputChange: onDropLocationInputChange, confirmDropoff: function () {
                    onConfirmDropoff(true);
                }, scannedLocationIncorrect: scannedLocationIncorrect, setScannedLocationIncorrect: setScannedLocationIncorrect }, void 0)) : currentActiveSubscreen === 'packingStationLocation' ? (_jsx(DropLocation
            // onDropItem={onDropItem}
            , { 
                // onDropItem={onDropItem}
                currentPickRunTypeId: currentPickRunTypeId, inputTitle: t('Scan Packing Station'), topTitle: t('Go To Packing Station'), errorMsgText: errorMsgText, onDropLocationInputChange: onDropLocationInputChange, confirmDropoff: function () {
                    onConfirmDropoff(false);
                }, scannedLocationIncorrect: scannedLocationIncorrect, setScannedLocationIncorrect: setScannedLocationIncorrect, backBtn: function () { return backBtn('placeInTote'); } }, void 0)) : (_jsx(PickComplete, {}, void 0))] }), void 0));
};
PickSingle.defaultProps = {
    skipScanLocationScreen: false
};
export default PickSingle;
